import { StorefrontOrder, StorefrontOrderItem } from "src/components/checkout/types"
import { ResolvedListProductData } from "src/data/product-list-resolved/types"
import { WCAdminExistingOrderStatus, WCAdminOrderData } from "src/data/woocommerce/wcAdminTypes"
import { createMap } from "src/utilities/lookup"

export function mapOrder(order: WCAdminOrderData | null, products: ResolvedListProductData[]) {
  if (!order) {
    throw new Error("Order not found")
  }

  const productsBySku = createMap(products, (product) => product.sku)

  const items = order.line_items.map((item) => {
    const product = productsBySku.get(item.sku)

    if (!product) {
      throw new Error(`Product not found for order item SKU: ${item.sku}`)
    }

    return { ...item, product } satisfies StorefrontOrderItem
  })

  return { ...order, line_items: items } satisfies StorefrontOrder
}

export function getOrderTitle(orderStatus: WCAdminExistingOrderStatus | undefined) {
  switch (orderStatus) {
    case "pending":
      return "Zahlung ausstehend"
    case "processing":
      return "In Bearbeitung"
    case "on-hold":
      return "Überweisung ausstehend"
    case "completed":
      return "Abgeschlossen"
    case "cancelled":
      return "Abgebrochen"
    case "refunded":
      return "Rückerstattet"
    case "failed":
      return "Fehlgeschlagen"
    default:
      return "Unbekannt"
  }
}
